/**
 * Label to show for a tenant from the API (`calendarAssociationTenant`).
 * Format: shortName (name). displayName is not shown.
 */
export function resolveTenantDisplayName(tenant, fallbackId = "") {
  if (!tenant || typeof tenant !== "object") {
    return String(fallbackId || "").trim();
  }
  const shortName = String(tenant.shortName ?? "").trim();
  const name = String(tenant.name ?? "").trim();

  if (shortName) {
    if (name && name !== shortName) {
      return `${shortName} (${name})`;
    }
    return shortName;
  }
  if (name) return name;
  return String(fallbackId || "").trim();
}
